$ = jQuery;
function anchorAttributes() {
  $(document).ready(function() {
    $('article.node--type-global-home-page .global-home-page-section-second .field--name-field-section-second .field__item:nth-child(3) a, ' +
      'article.node--type-global-home-page .global-home-page-section-third .field--name-field-section-third .field__item:nth-child(3) a, ' +
      'article.node--type-global-home-page .global-home-page-section-fourth .field--name-field-section-fourth .field__item:nth-child(2) a, ' +
      '.region-footer-top .footer-logos-container a, ' +
      '#block-stay-in-touch .stay-touch-social-icon ul li a, ' +
      '#block-footer-information .content .text-formatted p:nth-child(1) a').attr({
      'data-event-category': 'External Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': '{{Click URL}}',
    });
    $('#block-stay-in-touch .stay-touch-social-icon ul li a:nth-child(1) i').attr({
      'data-event-category': 'External Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'https://www.linkedin.com/company/vifor-pharma/',
    });
    $('#block-stay-in-touch .stay-touch-social-icon ul li a:nth-child(2) i').attr({
      'data-event-category': 'External Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'https://twitter.com/viforpharma',
    });
    $('article.node--type-global-home-page .global-home-page-section-second .field--name-field-section-second .field__item:nth-child(4) a, ' +
      'article.node--type-global-home-page .global-home-page-section-fifth .field--name-field-section-fifth .field__item:nth-child(2) a').attr({
      'data-event-category': 'Contact Us',
      'data-event-action': '{{Page Path}}',
      'data-event-label': '{{Email Address}}',
    });
    $('article.node--type-global-home-page .paragraph--type--abbreviations-references .field--name-field-reference-button').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'References',
    });
    $('.opt-in-main-container #opt-in .block-webform form .form-actions input').attr({
      'data-event-category': 'Contact Us',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Opt-In Form',
    });
    $('.webform-confirmation .back-to-form-link, .webform-confirmation .webform-confirmation__back').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Back to Form',
    });

    $('article[about="/ch-de/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(1) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'About SHPT',
    });
    $('article[about="/ch-fr/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(1) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'About SHPT',
    });
    $('article[about="/ch-de/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(2) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'What is Rayaldee',
    });
    $('article[about="/ch-fr/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(2) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'What is Rayaldee',
    });
    $('article[about="/ch-de/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(3) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Efficacy of Rayaldee',
    });
    $('article[about="/ch-fr/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(3) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Efficacy of Rayaldee',
    });
    $('article[about="/ch-de/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(4) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Tolerability of Rayaldee',
    });
    $('article[about="/ch-fr/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(4) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Tolerability of Rayaldee',
    });
    $('article[about="/ch-de/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(5) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Rayaldee dosing regimen',
    });
    $('article[about="/ch-fr/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(5) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Rayaldee dosing regimen',
    });
    $('article[about="/ch-de/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(6) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Rayaldee patients',
    });
    $('article[about="/ch-fr/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(1) .paragraph--type--two-columns > .field--name-field-column > .field__item > .paragraph--type--column > .field--name-field-content .field__item:nth-child(6) a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Rayaldee patients',
    });
    $('article[about="/ch-de/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(2) > .paragraph--type--one-column a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Rayaldee Resources',
    });
    $('article[about="/ch-fr/home"] .node__content > .field--name-field-content #rayaldee-information > .field--name-field-content > .field__item:nth-child(2) > .paragraph--type--one-column a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Rayaldee Resources',
    });
    $('article[about="/ch-de/home"] .node__content > .field--name-field-content > .field__item:nth-child(2) a').attr({
      'data-event-category': 'PDF Download',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Download SMPC',
    });
    $('article[about="/ch-fr/home"] .node__content > .field--name-field-content > .field__item:nth-child(2) a').attr({
      'data-event-category': 'PDF Download',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Download SMPC',
    });
    $('article[about="/ch-de/home"] > div.field.field--name-field-full-width-blocks.field--type-entity-reference-revisions.field--label-hidden.field__items > div:nth-child(3) > div > div > div.field.field--name-field-link.field--type-link.field--label-hidden.field__item > a').attr({
      'data-event-category': 'Contact Us',
      'data-event-action': '{{Page Path}}',
      'data-event-label': '{{Email Address}}',
    });
    $('article[about="/ch-fr/home"] > div.field.field--name-field-full-width-blocks.field--type-entity-reference-revisions.field--label-hidden.field__items > div:nth-child(3) > div > div > div.field.field--name-field-link.field--type-link.field--label-hidden.field__item > a').attr({
      'data-event-category': 'Contact Us',
      'data-event-action': '{{Page Path}}',
      'data-event-label': '{{Email Address}}',
    });
    $('#block-rayaldee-v2-content > div > article > div.field.field--name-field-full-width-blocks.field--type-entity-reference-revisions.field--label-hidden.field__items > div:nth-child(4) > div > div > div.clearfix.text-formatted.field.field--name-field-reference-button.field--type-text.field--label-hidden.field__item').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'References',
    });
    $('#block-underreferenceinfo > div.open-box').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Short information',
    });
    $('#block-signup-for-alerts a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Sign up and get the latest news',
    });
    $('#block-signup-for-alerts-global a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Sign up and get the latest news',
    });
    $('#block-footer-information > div > div > div > span.view-more').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Show more ',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(1) .accordion-tab-title, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(1) .accordion-tab-title').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Download materials',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(1) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(1) a.cover-link, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(1) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(1) a.cover-link').attr({
      'data-event-category': 'PDF Download',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Rayaldee dosing guide',
    });
    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(1) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(2) a.cover-link, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(1) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(2) a.cover-link').attr({
      'data-event-category': 'External Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': '{{Click URL}}',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(1) iframe, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(1) iframe').attr({
      'data-event-category': 'Video',
      'data-event-label': 'SHPT & Rayaldee Explanatory Video',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(2) iframe, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(2) iframe').attr({
      'data-event-category': 'Video',
      'data-event-label': 'MoA Video',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(3) iframe, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(3) iframe').attr({
      'data-event-category': 'Video',
      'data-event-label': 'Patient Interview',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(4) iframe, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(4) iframe').attr({
      'data-event-category': 'Video',
      'data-event-label': 'Pill Animation',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(1) iframe, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(1) iframe').attr({
      'data-event-category': 'Video',
      'data-event-label': 'Webinar Prof. Ambühl',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(2) iframe, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(2) iframe').attr({
      'data-event-category': 'Video',
      'data-event-label': 'Webinar Dr. Ernandez',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(3) iframe, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(3) iframe').attr({
      'data-event-category': 'Video',
      'data-event-label': '50 is the new 30',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(4) iframe, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(4) iframe').attr({
      'data-event-category': 'Video',
      'data-event-label': 'SGN symposium ERC & Veltassa',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(5) a.cover-link, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(5) a.cover-link').attr({
      'data-event-category': 'External Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': '{{Click URL}}',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(6) a.cover-link, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-content > .field__item > .paragraph--type--resources > .field--name-field-content > .field__item:nth-child(6) a.cover-link').attr({
      'data-event-category': 'External Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': '{{Click URL}}',
    });

    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-title, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(2) .accordion-tab-title').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Watch videos',
    });
    $('article[about="/ch-de/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-title, article[about="/ch-fr/resources"] .paragraph--type--accordion > .field--name-field-content > .field__item:nth-child(3) .accordion-tab-title').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Watch webinars',
    });
    $('#login-popup-modal-1 #iam-hcp-button, ' +
      '#login-popup-modal-1 #iam-hcp-button i, ' +
      '#login-popup-modal-1 #iam-hcp-button h4, ' +
      '#login-popup-modal-1 #iam-hcp-button p, ' +
      '#login-popup-modal-1 #iam-hcp-button img').attr({
      'data-event-category': 'HCP Confirmation',
      'data-event-action': 'Step 1',
      // 'data-event-label': '{{Country}}',
    });
    $('#login-popup-modal-1 .big-buttons-row > a, ' +
      '#login-popup-modal-1 .big-buttons-row > a div, ' +
      '#login-popup-modal-1 .big-buttons-row > a div i, ' +
      '#login-popup-modal-1 .big-buttons-row > a div h4, ' +
      '#login-popup-modal-1 .big-buttons-row > a div h4 span, ' +
      '#login-popup-modal-1 .big-buttons-row > a p, ' +
      '#login-popup-modal-1 .big-buttons-row > a p img').attr({
      'data-event-category': 'HCP Confirmation',
      'data-event-action': 'No',
    });

    $('#login-popup-modal-1 .us-row > a').attr({
      'data-event-category': 'Resident Selector',
      'data-event-action': 'Yes',
    });

    $('#login-popup-modal-2 button').attr({
      'data-event-category': 'HCP Confirmation',
      'data-event-action': 'Step 2',
    });

    $('a.site-branding__logo').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Logo',
    });
    $('#block-rayaldee-v2-main-menu nav ul li a').each(function(){
      $(this).attr({
        'data-event-category': 'Internal Link Click',
        'data-event-action': '{{Page Path}}',
        'data-event-label': '{{Click Text}}',
      });
    });

    $('#block-rayaldee-v2-footer ul li a, #block-footer-global-menu ul li a').each(function(){
      $(this).attr({
        'data-event-category': 'Internal Link Click',
        'data-event-action': '{{Page Path}}',
        'data-event-label': '{{Click Text}}',
      });
    });
    $('article[about="/prescribing-information-global"] a.file-download,' +
      'article[about="/ch-de/prescribing-information"] a.file-download,' +
      'article[about="/ch-fr/prescribing-information"] a.file-download').attr({
      'data-event-category': 'PDF Download',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Download SMPC',
    });

    $('div.language-switcher-container > nav#block-global-menu ul li a').attr({
      'data-event-category': 'Internal Link Click',
      'data-event-action': '{{Page Path}}',
      'data-event-label': 'Global',
    });

    $('[about="/ch-de/resources"] iframe, [about="/ch-fr/resources"] iframe').each(function(){
      let html = '<div class="video-button-trigger" data-event-category="Video" data-event-label="'+ $(this).attr('data-event-label') +'"></div>';
      $(this).parent().prepend(html);
    });
    $("body").on("click", "div.video-button-trigger", function() {
      $(this).remove();
      // console.log($(this).parent().find('iframe').contents().find('button.play').trigger('click'));
      // $(this).parent().find('iframe').contentWindow.$('button.play').trigger('click');
      // document.getElementById('ifrmMsg').contentWindow.$('a:first').trigger('click');
    });

    let country = '';
    $('.default-country-selector li').on('click', function(){
      country = $(this).find('p').text();
      $('#login-popup-modal-2 button').attr({'data-event-label': country});
    });

    $('[data-event-action="{{Page Path}}"]').attr('data-event-action', window.location.pathname);

    $('a[data-event-label="{{Click URL}}"]').each(function (){
      let href = $(this).attr('href');
      $(this).attr('data-event-label', href);
    });

    $('a[data-event-label="{{Email Address}}"]').each(function (){
      let href = $(this).attr('href');
      let regex = /([a-zA-Z0-9._+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
      let matches = regex.exec(href);
      $(this).attr('data-event-label', matches[1]);
    });

    $('a[data-event-label="{{Click Text}}"]').each(function(){
      let link_text = $(this).text();
      $(this).attr('data-event-label', link_text);
    });
  });
}
